import React from 'react';
import { Control } from 'react-hook-form';
import { InputView, InputAdornment } from '@infoods/lifebase-ui';
import { LbNumericFormatInput } from '../../../../shared/components/form-components';
import { Mode } from '../../../../general-types';
import { FeeTermsFormValues } from '../../../interfaces/feeTerms';
import { getPriceView } from '../../../../shared/utils/stringUtils';
import { getIsNullish } from '../../../../shared/utils/jsUtils';

type ClientFeeInputProps = {
  control: Control<FeeTermsFormValues>;
  mode: Mode;
  clientFee: number;
  countOfClients?: number;
};

const ClientFeeInput = ({
  control,
  mode,
  clientFee,
  countOfClients,
}: ClientFeeInputProps) => {
  if (mode === 'VIEW') {
    const clientFeeForDisplay = getPriceView(clientFee);

    const helperText = countOfClients
      ? `${countOfClients} Clients x ${clientFeeForDisplay} = ${getPriceView(
          clientFee * countOfClients,
        )}`
      : '';

    const inputValue = getIsNullish(clientFee)
      ? 'Not set'
      : `${clientFeeForDisplay} / per client`;

    return (
      <InputView className="private-info" value={inputValue} helperText={helperText} />
    );
  }

  return (
    <LbNumericFormatInput
      control={control}
      name="activeClientFee"
      variant="outlined"
      size="small"
      prefix="$"
      rules={{ required: 'Active Client Fee is required' }}
      decimalScale={2}
      InputProps={{
        endAdornment: <InputAdornment position="end">per client</InputAdornment>,
      }}
      fixedDecimalScale
      selectValueOnFocus
      allowNegative={false}
    />
  );
};

export { ClientFeeInput };
